import styled from "styled-components"

export const RowCommentWrapper = styled.div`
    .ask_box {
    &_item {
        padding-bottom: 12px;
        &_top {
            display: flex;
            position: relative;
            &_img {
                width: 60px;
                height: 60px;
                margin-right: 12px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: contain;
                    display: block;
                    border: 1px solid #796d6d;
                }
            }
            &_right {
                span {
                    display: flex;
                    p {
                        margin-right: 8px;
                        margin-bottom: 0;                       
                    }
                }
                &_time {
                    color: #626060;
                    font-size: 0.9rem;
                }
            }
        }
        &_content {
            p {
                color: #000000;
            }
        }
        &_bottom {
            &_login {
                border: none;
                outline: none;
                height: 30px;
                width: 200px;
                background-color: #2f80ed;
                color: #fff;
                border-radius: 4px;
                margin-top: 12px;
                &:hover {
                    background-color: #fed700;
                }
            }
            &_left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 12px 0 0;
                span {
                    display: flex;
                    align-items: center;
                    font-size: 0.8rem;
                    i {
                        margin-right: 8px;
                    }
                    cursor: pointer;
                    
                }
            }
            &_sent {
                margin-top: 12px;
                display: flex;
                align-items: center;
                height: 40px;
                align-items: center;
                input {
                    flex: 1;
                    padding: 4px;
                    font-size: 1rem;
                    color: #000000;
                    outline: none;
                    border: 1px solid #2f80ed;
                    height: 30px;
                }
                span {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    cursor: pointer;
                    
                    i {
                        transform: rotate(135deg);
                        font-size: 1.6rem;
                    }
                }
            }
        }
    }
}

.comment_control {
    position: absolute;
    right: 10px;
    top: 0;
    i {
        cursor: pointer;
        color: #626060;
        &:hover {
            color: #e2c1c1;
        }
    }
    &_box {
        box-shadow: 1px 1px 10px rgb(0 0 0 / 15%);
        span {
            display: block;
            font-size: 0.8rem;
            font-weight: 500;
            color:#626060;
            display: flex;
            justify-content: center;
            padding: 4px;
            &:hover {
                background-color: #e2c1c1;
                cursor: pointer;
            }
        }
    }
}
`
